import clicksound from '../components/music/click.mp3';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const StoryModal = ({ show, handleClose }) => {
    const { t } = useTranslation();
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = t("modal_story_dakon", { returnObjects: true });

    const playClickSound = () => {
        const audio = new Audio(clicksound);
        audio.play();
    };

    const handleNext = () => {
        playClickSound();
        if (currentSlide < slides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            handleClose();
        }
    };

    const handleBack = () => {
        playClickSound();
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    const handleModalClose = () => {
        playClickSound();
        handleClose();
    };

    if (!show) return null;

    return (
      <div className="fixed inset-0 flex items-end p-5 bg-black bg-opacity-50">
        <div className="bg-white lg:p-6 sm:p-4 md:p-4 rounded-3xl shadow-lg mx-auto relative">
          <button
            onClick={handleModalClose}
            className="close-button absolute top-2 right-2 px-3  text-gray-600 hover:text-gray-900 font-bold text-4xl sm:text-3xl"
          >
            &times;
          </button>
          <h2 className="lg:text-xl font-semibold lg:mb-4 sm:text-md sm:mb-2 md:mb-2">
            {slides[currentSlide].title}
          </h2>
          <p className="lg:mb-4 sm:mb-2 sm:text-xs md:mb-2 md:text-sm">
            {slides[currentSlide].content}
          </p>
          <div className="flex justify-between">
            <button
              onClick={handleBack}
              className="PrevButton text-white px-4 py-2 rounded-full"
              disabled={currentSlide === 0}
            >
              {t("Kembali")}
            </button>
            <button
              onClick={handleNext}
              className="NextButton text-white px-4 py-2 rounded-full "
            >
              {currentSlide < slides.length - 1 ? t("Next") : t("Tutup")}
            </button>
          </div>
        </div>
      </div>
    );
};

export default StoryModal;
